module.exports = __webpack_public_path__ + "img/6.718f1bbd.png";